import styled from 'styled-components';

export const ModalWebWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ModalContainer = styled.div`
  background-color: #ffffff;
  border-radius: 4px;
  padding: 18px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  margin-left: 20px;
  margin-right: 20px;
`;

export const Container = styled.div`
  min-width: 250px;
`;

export const ContentContainer = styled.div`
  padding-top: 5px;
`;

export const Content = styled.p`
  font-size: 13px;
  line-height: 16px;
  margin-top: 5px;
  font-family: 'Rubik';
  font-weight: 400;
  color: #000000;
`;

export const ButtonView = styled.div`
  padding-top: 30px;
`;

export const ButtonTextWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const ButtonText = styled.button`
  padding: 8px 16px;
  font-size: 14px;
  color: #ff6d38;
  cursor: pointer;
  font-family: 'Rubik';
  font-weight: 700;
  background-color: transparent;
  transition: background-color 0.3s, color 0.3s;
  border: none;
  outline: none;
`;